/**
 * Runtime configuration. Values are injected at build time from the web app's
 * environment (see `.env`). Copy `.env.example` to `.env` and fill in your keys.
 */

function required(value: string | undefined, name: string): string {
  if (!value) {
    throw new Error(
      `[jobs-saver/web] Missing required env var "${name}". Create apps/web/.env (see .env.example).`,
    );
  }
  return value;
}

export const CLERK_PUBLISHABLE_KEY = required(
  import.meta.env.VITE_CLERK_PUBLISHABLE_KEY,
  'VITE_CLERK_PUBLISHABLE_KEY',
);

export const API_BASE_URL = required(
  import.meta.env.VITE_API_BASE_URL,
  'VITE_API_BASE_URL',
);
